module.exports = __webpack_public_path__ + "img/icon_32.fe348256.png";